import { Button, Input } from '@artosera/ui';
import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { authApi } from '../../api/auth.js';
import { estApiError, estErreurReseau } from '../../api/errors.js';
import { AuthCard } from '../AuthCard.js';
import { Field } from '../Field.js';
import styles from './ConnexionPage.module.css';

/**
 * `/mot-de-passe/oublie` : l'API rend le même message que le compte existe ou
 * non (`docs/dev/api.md` § 3) — aucune énumération de comptes côté client non plus.
 */
export function MotDePasseOubliePage(): JSX.Element {
  const { t } = useTranslation('regie');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(): Promise<void> {
    setErreur(null);
    setEnCours(true);
    try {
      const reponse = await authApi.motDePasseOublie(email);
      setMessage(reponse.message);
    } catch (error) {
      if (estApiError(error)) {
        setErreur(error.message);
      } else if (estErreurReseau(error)) {
        setErreur(t('auth.connexion.erreurReseau'));
      } else {
        setErreur(t('commun.erreurReseau'));
      }
    } finally {
      setEnCours(false);
    }
  }

  return (
    <AuthCard
      title={t('auth.motDePasseOublie.titre')}
      subtitle={t('auth.motDePasseOublie.sousTitre')}
    >
      {message ? (
        <p className={styles.statut} role="status">
          {message}
        </p>
      ) : (
        <form
          onSubmit={(event) => {
            event.preventDefault();
            void soumettre();
          }}
          noValidate
        >
          <Field label={t('auth.motDePasseOublie.champEmail')} htmlFor="oubli-email">
            <Input
              id="oubli-email"
              type="email"
              autoComplete="email"
              required
              className={styles.pleineLargeur}
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </Field>

          {erreur ? (
            <p className={styles.erreur} role="alert">
              {erreur}
            </p>
          ) : null}

          <Button type="submit" className={styles.envoi} loading={enCours}>
            {t('auth.motDePasseOublie.bouton')}
          </Button>
        </form>
      )}

      <p className={styles.lienOubli}>
        <Link to="/connexion">{t('auth.motDePasseOublie.retour')}</Link>
      </p>
    </AuthCard>
  );
}
